// extracted by mini-css-extract-plugin
module.exports = {"list":"xo5Ti_O_"};